export const MAP_CONTOUR_COLOR = '#eeee55';
export const HELPER_CONTOUR_COLOR = '#cb212f ';
export const EXISTING_ZONE_COLOR = '#124CFF';
export const EDITABLE_ZONE_COLOR = '#ffffff';
export const HIGHLIGHTED_ZONE_COLOR = '#fa0b65';
export const GRAY_MARKER_COLOR = '#D1D1D1';
export const ZONE_COLOR_FILL = '#ffffff';

export const CENTER_OF_POLAND_LAT_LNG = {
  lat: 51.9189046,
  lng: 19.1343786
};

export enum MarkerSize {
  Small = 'small',
  Normal = 'normal',
  Big = 'big'
}

export enum MarkerShape {
  Pin = 'Pin',
  Circle = 'Circle'
}

export type CanvasMarkerIcon = {
  icon: google.maps.Icon;
  shape?: google.maps.MarkerShape;
};
export interface MarkerSizeConfig {
  width: number;
  height: number;
  fontSize: number;
  circleCenterX: number;
  circleCenterY: number;
  circleRadius: number;
}

export const MarkerSizeMap: Record<MarkerSize, MarkerSizeConfig> = {
  [MarkerSize.Small]: {
    width: 40,
    height: 30,
    circleRadius: 8,
    fontSize: 12,
    circleCenterX: 20,
    circleCenterY: 12
  },
  [MarkerSize.Normal]: {
    width: 65,
    height: 50,
    circleRadius: 13,
    fontSize: 18,
    circleCenterX: 33,
    circleCenterY: 21
  },
  [MarkerSize.Big]: {
    width: 90,
    height: 70,
    circleRadius: 18,
    fontSize: 24,
    circleCenterX: 45,
    circleCenterY: 30
  }
};

export const CircleMarkerSizeMap: Record<MarkerSize, { radius: number; fontSize: number; padding?: number }> = {
  [MarkerSize.Small]: { radius: 7, fontSize: 10, padding: 4 },
  [MarkerSize.Normal]: { radius: 10, fontSize: 12, padding: 4 },
  [MarkerSize.Big]: { radius: 12, fontSize: 14, padding: 4 }
};
